<template>
  <div class="product-extras">
    <div class="nav nav-pills extras-tabs">
      <a 
        href="#"
        class="nav-link"
        :class="{active: extra.CODMODIFICADOR === current.CODMODIFICADOR}"
        :key="extra.CODMODIFICADOR"
        v-for="extra in extras"
        @click="selectExtra(extra)">
        {{ extra.DESCRIPCION }}
        <small class="badge badge-warning" :style="extraCounterStyle(extra)">
          {{ numOptionsSelected(extra) }} de {{ extra.LIMITE }} <!-- (MIN:{{extra.MINIMO}}) -->
        </small>
      </a>
    </div>
    <div class="extras-list">
      <ProductExtrasOption
        v-for="option in current.OPCIONES"
        :option="option" 
        :key="option.CODARTICULO"
        :selected="isOptionSelected(option)"
        @selectOption="onSelectOption"
      />
    </div>
  </div>
</template>
<script>
import ProductExtrasOption from './ProductExtrasOption'
export default {
  components: { ProductExtrasOption },
  props: {
    extras: { required: true }
  },
  data() {
    return {
      current: {},
      selected: []
    }
  },
  mounted() {
    this.current = this.extras.length > 0 ? this.extras[0] : {}
  },
  computed: {
    numSelected() {
      const extra = this.current
      let count = 0
      this.selected.forEach(e => {
        if (e.CODMODIFICADOR === extra.CODMODIFICADOR) count++
      })
      return count
    }
  },
  methods: {
    selectExtra(extra) {
      this.current = extra
    },
    extraCounterStyle(extra) {
      const extraFull = this.numOptionsSelected(extra) === extra.LIMITE
      const backgroundColor = extraFull
        ? extra.ESMENU ? '#28a745' : '#ffc108'
        : extra.ESMENU ? '#dc3645' : '#6c757c'
      const color = extraFull
        ? extra.ESMENU ? '#f2f2f2' : '#202020'
        : extra.ESMENU ? '#f2f2f2' : '#f2f2f2'
      return { backgroundColor, color }
    },
    numOptionsSelected(extra) {
      let count = 0
      this.selected.forEach(e => {
        if (e.CODMODIFICADOR === extra.CODMODIFICADOR) count++
      })
      return count
    },
    isOptionSelected(option) {
      return this.selected.filter(o => o.CODARTICULO === option.CODARTICULO)
        .length
    },
    currentSelected() {
      const extra = this.current
      const selected = []
      this.selected.forEach(e => {
        if (e.CODMODIFICADOR === extra.CODMODIFICADOR) selected.push(e)
      })
      return selected
    },
    onSelectOption(option) {
      const extra = this.current
      if (!this.isOptionSelected(option)) {
        if (extra.MULTISELEC === 'F') this.clearCurrent(option)
        if (extra.LIMITE - this.numSelected > 0) {
          this.onAddOption(option, extra)
        } else {
          alert(`LIMITE DE EXTRAS ES DE ${extra.LIMITE}`)
        }
      } else {
        if (
          extra.MULTISELEC === 'F' &&
          option.CODMODIFICADOR !== extra.CODMODIFICADOR
        ) {
          this.clearCurrent(option)
        }
        this.onDeleteOption(option)
      }
    },
    clearCurrent() {
      const extra = this.current
      this.selected = this.selected.filter(
        e => e.CODMODIFICADOR !== extra.CODMODIFICADOR
      )
    },
    onAddOption(option) {
      const extra = this.current
      option.CODMODIFICADOR = extra.CODMODIFICADOR
      this.selected.push(option)
      const options = this.currentSelected()
      this.$emit('optionsChanged', { extra, options })
      if (
        (option.MODIFICADORES && option.MODIFICADORES.length > 0) ||
        (option.FORMATOS && option.FORMATOS.length > 0)
      )
        this.$emit('optionMenuSelected', { extra, option })
    },
    onDeleteOption(option) {
      const extra = this.current
      this.selected = this.selected.filter(
        o => o.CODARTICULO !== option.CODARTICULO
      )
      const options = this.currentSelected()
      this.$emit('optionsChanged', { extra, options })
    }
  }
}
</script>
<style lang="scss">
$selected-color: #27a2b8;

.product-extras {
  .extras-tabs {
    display: flex;

    .nav-link {
      align-items: flex-end;
      border-bottom: 0.2rem solid #f2f2f2;
      border-radius: 0.4rem 0.4rem 0 0;
      color: #40464b;
      display: flex;
      flex: 1;
      font-size: 0.82rem;
      justify-content: center;
      min-height: 3rem;
      padding: 0 0 0.32rem 0;
      position: relative;
      text-align: center;

      @media screen and (max-width: 340px) {
        font-size: 0.7rem !important;
      }

      &.active {
        background-color: transparent;
        border-bottom: 0.2rem solid $selected-color;
        color: $selected-color;
      }

      .badge {
        position: absolute;
        top: 0.2rem;
        right: 0;
        font-size: 0.5rem;
        font-weight: normal;
      }
    }
  }

  .extras-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.4rem;
    grid-auto-rows: minmax(5rem, 6.4rem);

    @media screen and (max-width: 340px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Order/OrderAddProductModal/ProductExtras.vue